export default function () {

  function dateScroll() {
		$('.js-date-up').on('click',function(){
			let target = $(this).parent().parent().parent().prev().offset().top;
			console.log(target);
			$('html, body').animate({
				scrollTop: target
			},200);
			return false;;
		});
		$('.js-date-down').on('click',function(){
			let target = $(this).parent().parent().parent().next().offset().top;
			console.log(target);
			$('html, body').animate({
				scrollTop: target
			},200);
			return false;;
		});
    
	}
  dateScroll();
}